// extracted by mini-css-extract-plugin
export default {"cardBase":"styles_cardBase__o+nQS","emptyDivArea":"styles_emptyDivArea__KttRj"};